import { cn } from '@/lib/utils'

import { DocumentHeader } from './document-header/document-header'
import { DocumentImages } from './document-images/document-images'
import { useCurrentDocument } from './use-current-document'

export const CurrentDocument = () => {
  const { currentDocumentName, currentPage, totalPages, imgUrls, handleChangePage } = useCurrentDocument()

  return (
    <div className={cn('flex flex-col items-center', 'w-full')}>
      <DocumentHeader
        name={currentDocumentName || ''}
        currentPage={currentPage}
        totalPages={totalPages}
        onChangePage={handleChangePage}
      />

      <div className={cn('mt-6', 'w-full')}>
        <DocumentImages currentPage={currentPage} imgUrls={imgUrls} />
      </div>
    </div>
  )
}
